import { InlineWidget } from "react-calendly";
import { Output } from "valibot";

import { ChatDataSchema } from "components/SonicBot/schemas";
import { ReactComponent as IconClose } from "assets/images/icons/close-black.svg";

type Props = {
  chatbotColor: string;
  chatData: Output<typeof ChatDataSchema>;
  integrationLink: string;
  setIntegrationLink: React.Dispatch<React.SetStateAction<string | null>>;
};

function IntegrationInlineWidget(props: Props) {
  const { chatbotColor, chatData, integrationLink, setIntegrationLink } = props;

  return (
    <div className="relative">
      {/* Calendly inline widget begin */}
      <InlineWidget
        url={integrationLink}
        styles={{
          height: "86vh",
        }}
        pageSettings={{
          hideEventTypeDetails: true,
          hideLandingPageDetails: true,
          hideGdprBanner: true,
        }}
        iframeTitle={"Botsonic Calendly Meeting Scheduler"}
      />
      {/* Calendly inline widget end */}
      <button
        onClick={() => {
          setIntegrationLink(null);
          chatData.push({
            message: `You've cancelled the meeting.`,
            sent: false,
          });
        }}
        className="absolute left-2 top-2 flex h-6 w-6 items-center justify-center rounded-full text-white outline-none"
        style={{ backgroundColor: chatbotColor }}
        data-tip="Close"
      >
        <IconClose />
      </button>
    </div>
  );
}

export default IntegrationInlineWidget;
